export const ERRORS_CODES = Object.freeze({
  INVALID_REFUND_HOLDER_DOCUMENT: 'INVALID_REFUND_HOLDER_DOCUMENT',
});
